import React from "react";
import CardHeader from "../../../../Universal/CardHeader.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import DonutChart from "../../../../Universal/DonutChart.component";
import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";

const LiabilitiesPieChart = ({ donutChartData }) => {
  return (
    <div className="viewPollingDetailsContainer">
      <CardHeader
        title="Categories wise liabilities"
        actionBtn={<SelectFilter />}
        headerStyle={{ borderBottom: "none" }}
      />
      <div className="flex-row g-05 space-between w-full h-half flex-1">
        <div className="h-full w-half">
          <DonutChart
            data={donutChartData}
            title="Type of liabilities"
            valuemapKey="contribution"
          />
        </div>

        <div className="w-half h-full flex-col align-start justify-start">
          <ScrollableCardTable thead={["Categories", "Contribution(%)"]}>
            {donutChartData &&
              donutChartData.map((_data, index) => {
                return (
                  <tr
                    style={{
                      "--pollingDonutChartTableDetailsIndicatorColor":
                        _data.positionColor,
                    }}
                    className="pollingDetailsTableData w-full flex-row align-center justify-arround"
                  >
                    <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.categories}
                    </td>
                    {/* <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.appearanceCount}
                    </td> */}
                    <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.contribution} %
                    </td>
                  </tr>
                );
              })}
          </ScrollableCardTable>
        </div>
      </div>
    </div>
  );
};

export default LiabilitiesPieChart;
